import {useEventBus} from "../../../assets-dev/ts/modules/use-event-bus";

const enum CollapseState {
    Closed = 'closed',
    Open = 'open',
}

export class ComponentCollapse {
    private readonly openClass = 'expanded';
    private readonly itemClass = '.hd-collapse__item';
    private readonly itemTitleClass = '.hd-collapse__item-title';
    private readonly contentWrapperClass = '.hd-collapse__item-content-wrapper';
    private readonly itemContentClass = '.hd-collapse__item-content';

    private el: HTMLElement;
    private item: HTMLElement | null;
    private title: HTMLElement | null;
    private contentWrapper: HTMLElement | null;
    private content: HTMLElement | null;
    private state: CollapseState;
    private alwaysOpen: boolean;

    private clickEventFn;
    private resizeEventFn;

    constructor(el: HTMLElement) {
        this.el = el;
        this.item = el.querySelector(this.itemClass);
        this.title = el.querySelector(this.itemTitleClass);
        this.contentWrapper = el.querySelector(this.contentWrapperClass);
        this.content = el.querySelector(this.itemContentClass);
        this.state = this.title && this.title.getAttribute('aria-expanded') === 'false' ? CollapseState.Closed : CollapseState.Open;
        this.alwaysOpen = !this.title;
    }

    public onInit() {
        if (this.title) {
            this.clickEventFn = this.toggle.bind(this);
            this.title.addEventListener('click', this.clickEventFn);

            this.resizeEventFn = this.onResize.bind(this);
            window.addEventListener('resize', this.resizeEventFn);
        } else {
            this.open();
        }
    }

    public onDestroy() {
        if (this.clickEventFn && this.title) {
            this.title.removeEventListener('click', this.clickEventFn);
        }
        if (this.resizeEventFn) {
            window.removeEventListener('resize', this.resizeEventFn);
        }
    }

    private onResize() {
        if (this.alwaysOpen) {
            return;
        }
        if (this.state === CollapseState.Open) {
            this.setHeight();
        }
    }

    private toggle() {
        this.state === CollapseState.Open ? this.close() : this.open();
    }

    private open() {
        this.state = CollapseState.Open;
        if (this.item) {
            this.item.classList.add(this.openClass);
        }
        if (this.title) {
            this.title.setAttribute('aria-expanded', 'true');
        }
        if (this.contentWrapper && this.content) {
            if (this.alwaysOpen) {
                this.contentWrapper.style.height = `auto`;
            } else {
                this.setHeight();
            }
        }
    }

    private close() {
        this.state = CollapseState.Closed;
        if (this.item) {
            this.item.classList.remove(this.openClass);
        }
        if (this.contentWrapper && this.content) {
            this.contentWrapper.style.height = `0`;
        }
    }

    private setHeight() {
        if (this.contentWrapper && this.content) {
            const height = this.content.getBoundingClientRect().height;
            this.contentWrapper.style.height = `${height}px`;
        }
    }

}

export function useComponentCollapse() {
    useEventBus('hd-collapse', ComponentCollapse);
}